import React from "react";
import Logo from "./Logo";

const FileMakerDown = () => (
  <div className="file_maker_down">
    <div>
      <h1>Offline</h1>
      <h6>
        We are currently offline due to planned maintenance.
      </h6>
      <p>
        Please contact us at the AFES National Office on{" "}
        <a href="tel:02 9697 0313">02 9697 0313</a> or email{" "}
        <a href="mailto:support@afes.org.au">support@afes.org.au</a> and we will
        be happy to assist you with your donation or any other request.
      </p>
      <p> We&apos;re sorry for this inconvenience.</p>
      <p>
        <strong>Please try again later.</strong>
      </p>
      <Logo />
    </div>
  </div>
);

export default FileMakerDown;
